import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { GeoJSONDataEntity } from 'src/app/models/data-entities/geojson-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-y-data-entity-view',
    templateUrl: './geojson-data-entity-view.component.html',
    styleUrls: ['./geojson-data-entity-view.component.css'],
    standalone: false
})
export class GeoJSONDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService,componentFactoryResolver, context);
  }
  geoJSONEntity: GeoJSONDataEntity;

  ngOnInit() {
    this.geoJSONEntity = <GeoJSONDataEntity>this.entity;
  }
}
